export default __webpack_public_path__ + "static/incomplete_stars-48d00daafb122ecf131607989175e51a.svg";